var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "attr.name",
    title: "Name",
    description: "A short variable-safe name used to represent the field. Should be camelCase or snake_case.",
    type: "attribute",
    use: {
        namespace: "ua.input"
    },
    tests: {
        validCamelCase: {
            must: true,
            run: function () {
                return validate({ title: "My Field", name: "fieldName" }, "whatever");
            }
        },
        validSnakeCase: {
            must: true,
            run: function () {
                return validate({ title: "My Field", name: "field_name" }, "value");
            }
        },
        invalid: {
            throw: "fields.attr.name.invalid",
            run: function () {
                return validate({ title: "My Field", name: "123@bad-name!" }, "value");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid Name",
            description: "The 'name' must be a valid variable-like identifier.",
            template: "Invalid name: '${name}' is not a valid variable name."
        }
    }
});

function validate(spec, value) {
    if (!spec.name) return;

    var valid = /^[a-zA-Z_][a-zA-Z0-9_]*$/.test(spec.name);
    if (!valid) {
        _.errors.invalid.throw({ name: spec.name });
    }
}
module.exports.validate = validate;
